export default "__VITE_ASSET__5f1LqX62__"